"use strict";

exports.__esModule = true;
exports.DataTableColumnWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _DataTableColumnElement = require("./DataTableColumnElement");
var _DataTableColumnFields = require("./DataTableColumnFields");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DataTableColumnWidget = exports.DataTableColumnWidget = {
  name: "DataTableColumn",
  icon: "th",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "DataTableColumnWidget.label",
    defaultMessage: "Column"
  }),
  getElementLabel: function getElementLabel(element) {
    return element.props.name;
  },
  createElement: function createElement(props) {
    return {
      type: "DataTableColumn",
      props: Object.assign({}, props),
      children: []
    };
  },
  children: [],
  showInPalette: false,
  isParent: false,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: ["fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlignment", "color"],
  requiresProps: [],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 256,
      min: 32,
      max: 1024
    },
    height: {
      "default": 64,
      min: 32,
      max: 768
    }
  },
  components: {
    Element: _DataTableColumnElement.DataTableColumnElement,
    Fields: _DataTableColumnFields.DataTableColumnFields
  }
};